/**
 * Returns the number of decimals of a given number
 * @param {number} value The number
 * @returns {number} The number of decimals
 */
export function countDecimals(value: number): number {
  if (Math.floor(value) === value) return 0;
  return value.toString().split('.')[1].length || 0;
}

/**
 * Sets the decimal places of a number
 * @param {number} value The number
 * @param {number} decimals The decimal places the number should have
 * @returns {number} The number with decimal places
 */
export function setDecimalPlaces(value: number, decimals: number): number {
  if (decimals < 0) {
    return value;
  }
  let numberOfDecimals = countDecimals(value);
  const factor = Math.pow(10, decimals - numberOfDecimals);
  return Number((value / factor).toFixed(decimals));
}
